<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.gamification_character_types', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex justify-between">
            <NavLinks :links="meta.navGroupLinks" />

            <div class="flex space-x-4 justify-end">
                <AppButton :href="meta.links.character_students_edit" element="inertia-link">
                    {{ $t('messages.assign') }}
                </AppButton>
                <AppButton :href="meta.links.create" element="inertia-link">
                    {{ $t('messages.create') }}
                </AppButton>
            </div>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.name') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.health_max') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.students', 2) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(characterType, index) in gamificationCharacterTypes"
                                :key="characterType.id"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div>{{ characterType.name }}</div>
                                    <img
                                        v-if="characterType.image_path"
                                        :src="characterType.image_path"
                                        :alt="characterType.name"
                                        class="max-w-none h-16 w-16 rounded-full ring-2 ring-white"
                                    />
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ characterType.health_max }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div class="flex -space-x-1 flex-wrap">
                                        <div
                                            class="flex shrink-0 -space-x-1 bg-white rounded-xl p-1"
                                            v-for="student in characterType.students"
                                            :key="student.id"
                                        >
                                            <img
                                                :src="student.avatar_or_default"
                                                alt=""
                                                :title="student.full_name"
                                                class="max-w-none h-8 w-8 rounded-full ring-2 ring-white"
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 text-right">
                                    <div class="flex space-x-1 justify-end">
                                        <!--                                        <InertiaSquareLinkButton-->
                                        <!--                                            action="show"-->
                                        <!--                                            :href="gamificationCharacterType.links.show"-->
                                        <!--                                        />-->
                                        <InertiaSquareLinkButton action="edit" :href="characterType.links.edit" />
                                        <InertiaSquareDeleteButton
                                            :href="characterType.links.delete"
                                            v-if="characterType.links.delete"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <div>{{ $t('messages.without_X', { element: $tc('messages.gamification_character_types', 1) }) }}:</div>
            <div class="flex -space-x-1 flex-wrap">
                <div
                    class="flex shrink-0 -space-x-1 bg-white rounded-xl p-1"
                    v-for="student in students"
                    :key="student.id"
                >
                    <img
                        :src="student.avatar_or_default"
                        alt=""
                        :title="student.full_name"
                        class="max-w-none h-8 w-8 rounded-full ring-2 ring-white"
                    />
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import AppButton from '@/components/AppButton.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        PanelPage,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        AppButton,
        NavLinks,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'gamificationSet', 'gamificationCharacterTypes', 'students', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
